import { CopyToClipboard } from '@dixa/lib-shared-habla';
import classnames from 'classnames';
import * as React from 'react';

import { RequestSimulatorFold } from './requestSimulatorFold';
import styles from './requestSimulatorObjectLine.module.scss';

type PropsT = {
  objKey: string;
  objValue: string | React.ReactElement<RequestSimulatorFold>;
  isArray: boolean;
  path: string;
  isLastLine: boolean;
};

const copyOnClick = (e: React.MouseEvent<HTMLElement, MouseEvent>) =>
  e.stopPropagation();

export const RequestSimulatorObjectLine: React.FC<PropsT> = ({
  objKey,
  objValue,
  isArray,
  path,
  isLastLine,
}) => {
  let commaAtEnd = true;
  if (
    isLastLine ||
    (objValue &&
      typeof objValue === 'object' &&
      objValue.type &&
      RequestSimulatorFold)
  ) {
    commaAtEnd = false;
  }

  const rootClass = classnames({
    [styles.root]: true,
    [styles.rootCanHover]: typeof objValue === 'object',
  });

  const isObject = typeof objValue !== 'string';

  return (
    <CopyToClipboard
      className={rootClass}
      textToCopy={path}
      onClick={copyOnClick}
      disabled={isArray || isObject}
    >
      <div>
        {!isArray && !isObject && (
          <React.Fragment>
            {objKey}
            {': '}
          </React.Fragment>
        )}
        {objValue}
        {commaAtEnd ? ',' : null}
        <span className={styles.copyText}>Copy</span>
        {commaAtEnd ? <br /> : null}
      </div>
    </CopyToClipboard>
  );
};
